import { Expose, Type } from 'class-transformer'
import { Package } from 'react-feather'

import { Barcode } from './Barcode'
import { Base } from './Base'
import { CaseBase } from './CaseBase'
import { ProductImage } from './ProductImage'
import { SkuBase } from './SkuBase'

export class Product extends Base {
  static type = 'product'
  static typeDisplay = 'Product'
  static icon = Package

  type = Product.type
  typeDisplay = Product.typeDisplay
  icon = Product.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''

  // The specific SKU being referenced for a given action
  // This allows for disambiguation in scaning product barcodes
  @Type(() => SkuBase)
  sku?: SkuBase

  @Type(() => CaseBase)
  cases?: CaseBase[]

  @Type(() => ProductImage)
  images?: ProductImage[] = []

  @Expose({ name: 'primary_barcode' })
  @Type(() => Barcode)
  primaryBarcode?: Barcode

  get primaryImage() {
    if (this.images && this.images.length) {
      return this.images[0]
    }
    return undefined
  }
}
